//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import newApi from '@/utils/newModuleApi'

export default {
  data () { return { list: [], total: 0, loading: true } },
  created () { this.load() },
  methods: {
    load () {
      this.loading = true
      this.$ajax.get(newApi.reviewErrorBook + '?page_size=50').then(res => {
        this.list = (res && res.list) || []
        this.total = (res && res.total) || this.list.length
      }).catch(() => {
        if (this.$vux) this.$vux.toast.text('加载失败')
      }).finally(() => { this.loading = false })
    },
    goReview () {
      this.$router.push({ path: '/reviewPractice_display', query: { review_type: 'error' } })
    },
    goPractice () {
      this.$router.push({ path: '/practice?hideTrans=true' })
    },
    goBack () {
      if (this.$route.query.from === 'mine') {
        this.$router.push({ path: '/mine', query: { hideTrans: 'true' } })
        return
      }
      this.$router.push({ path: '/reviewHome_display', query: { hideTrans: 'true' } })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/new/review/errorBook.vue